<header class="page-header-ui" [ngClass]="headerClasses" [style.background-image]="safeBackgroudImage"><ng-content></ng-content><sbpro-border [borderType]="borderType" [borderClasses]="borderClasses"></sbpro-border></header>
